import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.checkIns.filters.period_type);
  const selectedFilter = useSelector((state) => state.checkIns.selectedFilters.period_type);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilter}
      placeholder="Select Period Type"
      onSelectChange={(data) => {
        if (data.id !== selectedFilter.id) {
          dispatch(actionCreators.updatePeriodType(data));
        }
      }}
    />
  );
};

export default PeriodType;
